/* unplugin-vue-components disabled */import script from "./detailsHeader.vue?vue&type=script&lang=js"
export * from "./detailsHeader.vue?vue&type=script&lang=js"

import "./detailsHeader.vue?vue&type=style&index=0&id=7b03410b&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b03410b"]])

export default __exports__